import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

export const getMediaBySectionId = async (sectionId) => {
  const response = await axiosClient.get(`/api/admin/sections/${sectionId}/media`);
  return unwrapApiResponse(response);
};

export const updateMedia = async (mediaId, payload) => {
  const response = await axiosClient.put(`/api/admin/media/${mediaId}`, payload);
  return unwrapApiResponse(response);
};

export const uploadMedia = async (sectionId, formData) => {
  const response = await axiosClient.post(
    `/api/admin/sections/${sectionId}/media/upload`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return unwrapApiResponse(response);
};

export const deleteMedia = async (mediaId) => {
  const response = await axiosClient.delete(`/api/admin/media/${mediaId}`);
  return unwrapApiResponse(response);
};
